import { FETCH_VENDORS, CREATE_INVOICE, FETCH_BOXES, FETCH_INVOICE, FETCH_INVOICES } from "./types";

import { ITEMS_PER_PAGE } from "../../constants/constants";

const INITIAL_STATE = {
  vendorsList: {
    vendors: [],
    error: null,
    loading: true,
  },
  boxesList: {
    boxes: [],
    error: null,
    loading: true,
  },
  invoiceDetail: {
    invoice: null,
    error: null,
    loading: true,
  },
  invoicesList: {
    invoices: [],
    hasMore: false,
    error: null,
    loading: true,
  },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // --------------------------------------------------------------------------
    // FETCH_VENDORS
    // --------------------------------------------------------------------------
    case FETCH_VENDORS.init:
      return {
        ...state,
        vendorsList: { ...state.vendorsList, vendors: [], loading: true },
      };
    case FETCH_VENDORS.success:
      return {
        ...state,
        vendorsList: {
          vendors: action.payload,
          error: null,
          loading: false,
        },
      };
    case FETCH_VENDORS.failure:
      return {
        ...state,
        vendorsList: {
          ...state.vendorsList,
          vendors: [],
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // CREATE_INVOICE
    // --------------------------------------------------------------------------
    case CREATE_INVOICE.init:
      return {
        ...state,
        invoice: { ...state.invoice, error: null, loading: true },
      };
    case CREATE_INVOICE.success:
      return {
        ...state,
        invoice: { ...state.invoice, invoice: action.payload, error: null, loading: false },
      };
    case CREATE_INVOICE.failure:
      return {
        ...state,
        invoice: { ...state.invoice, invoice: null, error: action.payload.data || { message: action.payload.message }, loading: false },
      };
    // --------------------------------------------------------------------------
    // FETCH_BOXES
    // --------------------------------------------------------------------------
    case FETCH_BOXES.init:
      return {
        ...state,
        boxesList: { ...state.boxesList, boxes: [], error: null, loading: true },
      };
    case FETCH_BOXES.success:
      return {
        ...state,
        boxesList: { ...state.boxesList, boxes: action.payload, error: null, loading: false },
      };
    case FETCH_BOXES.failure:
      return {
        ...state,
        boxesList: { ...state.boxesList, boxes: [], error: action.payload.data || { message: action.payload.message }, loading: false },
      };
    // --------------------------------------------------------------------------
    // FETCH_INVOICE
    // --------------------------------------------------------------------------
    case FETCH_INVOICE.init:
      return {
        ...state,
        invoiceDetail: { ...state.invoiceDetail, invoice: null, error: null, loading: true },
      };
    case FETCH_INVOICE.success:
      return {
        ...state,
        invoiceDetail: { ...state.invoiceDetail, invoice: action.payload, error: null, loading: false },
      };
    case FETCH_INVOICE.failure:
      return {
        ...state,
        invoiceDetail: {
          ...state.invoiceDetail,
          invoice: null,
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_INVOICES
    // --------------------------------------------------------------------------
    case FETCH_INVOICES.init:
      return {
        ...state,
        invoicesList: { ...state.invoicesList, hasMore: false, error: null, loading: true },
      };
    case FETCH_INVOICES.success:
      return {
        ...state,
        invoicesList: {
          ...state.invoicesList,
          invoices: action.payload.results,
          hasMore: action.payload.next !== null,
          pages: Math.ceil(action.payload.count / ITEMS_PER_PAGE),
          error: null,
          loading: false,
        },
      };
    case FETCH_INVOICES.failure:
      return {
        ...state,
        invoicesList: {
          ...state.invoicesList,
          invoices: [],
          pages: 1,
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    default:
      return state;
  }
};
